import { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import BaseApi from "./BaseApi";

const BASE_URL = '/tenant';

class TenantApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async getTenantViewById(id: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(this.baseUrl + `/tenant-view/tenant-id/${id}`);
    }

    public async queryViews(request: QueryTenantViewsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/tenant-view/query', request);
    }

    public async getAllViews(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/tenant-view/all');
    }

    public async resetTenantAdminPassword(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/tenant-database/reset-admin-password`, {
            tenantId: tenantId
        });
    }

    public async reInitializeTenantDatabase(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/tenant-database/init`, {
            tenantId: tenantId
        });
    }

}

interface QueryTenantViewsRequest {
    pageNo: number;
    pageSize: number;
    search?: string;
}

export default TenantApi;

